(() => {
  const body = document.body;
  const menuButton = document.querySelector('.menu-button');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileShopToggle = document.querySelector('.mobile-shop-toggle');
  const mobileShopCategories = document.querySelector('#MobileShopCategories');
  const scrim = document.querySelector('.scrim');
  const drawer = document.querySelector('.drawer');
  const searchPanel = document.querySelector('.search-panel');
  const cartItems = document.querySelector('.cart-items');
  const cartTotal = document.querySelector('.cart-total-value');
  const routes = window.Rhevelle || {};

  const escapeHtml = value => String(value ?? '').replace(/[&<>'"]/g, character => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[character]);

  function formatMoney(cents) {
    const value = Number(cents || 0);
    const format = routes.moneyFormat || '₹{{amount}}';
    const amount = (value / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const amountNoDecimals = Math.round(value / 100).toLocaleString('en-IN');
    return format
      .replace(/{{\s*amount_no_decimals\s*}}/g, amountNoDecimals)
      .replace(/{{\s*amount\s*}}/g, amount)
      .replace(/{{\s*amount_with_comma_separator\s*}}/g, amount.replace(/,/g, 'X').replace('.', ',').replace(/X/g, '.'))
      .replace(/{{\s*amount_no_decimals_with_comma_separator\s*}}/g, amountNoDecimals.replace(/,/g, '.'));
  }

  function setOverlay(open) {
    scrim?.classList.toggle('open', open);
    body.classList.toggle('no-scroll', open);
  }

  function closeMenu() {
    menuButton?.setAttribute('aria-expanded', 'false');
    menuButton?.setAttribute('aria-label', 'Open menu');
    mobileMenu?.classList.remove('open');
    mobileShopToggle?.setAttribute('aria-expanded', 'false');
    mobileShopToggle?.setAttribute('aria-label', 'Show Shop now categories');
    if (mobileShopCategories) mobileShopCategories.hidden = true;
    body.classList.remove('no-scroll');
  }

  function closeOverlays() {
    drawer?.classList.remove('open');
    drawer?.setAttribute('aria-hidden', 'true');
    searchPanel?.classList.remove('open');
    searchPanel?.setAttribute('aria-hidden', 'true');
    setOverlay(false);
  }

  function openDrawer() {
    closeMenu();
    closeOverlays();
    if (!drawer) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    setOverlay(true);
  }

  function openSearch() {
    closeMenu();
    closeOverlays();
    if (!searchPanel) return;
    searchPanel.classList.add('open');
    searchPanel.setAttribute('aria-hidden', 'false');
    setOverlay(true);
    setTimeout(() => document.querySelector('#site-search')?.focus(), 200);
  }

  function updateCartView(cart) {
    document.querySelectorAll('.bag-count').forEach(count => { count.textContent = cart.item_count; });
    if (cartTotal) cartTotal.innerHTML = formatMoney(cart.total_price);
    if (!cartItems) return;

    if (!cart.items.length) {
      cartItems.innerHTML = '<p class="cart-empty">Your bag is waiting for a drape.</p>';
      return;
    }

    cartItems.innerHTML = cart.items.map((item, index) => `
      <div class="cart-line${item.image ? '' : ' cart-line--no-image'}">
        ${item.image ? `<img src="${escapeHtml(item.image)}" alt="" width="58" height="72">` : ''}
        <div>
          <strong>${escapeHtml(item.product_title)}</strong>
          <span>${escapeHtml(item.variant_title || 'One size')} · ${formatMoney(item.final_line_price)}</span>
        </div>
        <button class="cart-remove" type="button" data-line="${index + 1}" aria-label="Remove ${escapeHtml(item.product_title)}">×</button>
      </div>
    `).join('');

    cartItems.querySelectorAll('[data-line]').forEach(button => {
      button.addEventListener('click', async () => {
        button.disabled = true;
        try {
          const response = await fetch(`${routes.cartChangeUrl}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: Number(button.dataset.line), quantity: 0 })
          });
          if (!response.ok) throw new Error('Unable to update the bag.');
          updateCartView(await response.json());
        } catch (error) {
          cartItems.insertAdjacentHTML('afterbegin', `<p class="form-status">${escapeHtml(error.message)}</p>`);
        }
      });
    });
  }

  async function refreshCart() {
    try {
      const response = await fetch(`${routes.cartUrl}.js`, { headers: { Accept: 'application/json' } });
      if (response.ok) updateCartView(await response.json());
    } catch (_) {
      // The server-rendered cart remains available if the Ajax refresh fails.
    }
  }

  async function addVariant(variantId, quantity = 1) {
    const response = await fetch(`${routes.cartAddUrl}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity) }] })
    });
    const payload = await response.json();
    if (!response.ok) throw new Error(payload.description || 'This piece could not be added.');
    await refreshCart();
    openDrawer();
  }

  menuButton?.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!open));
    menuButton.setAttribute('aria-label', open ? 'Open menu' : 'Close menu');
    mobileMenu?.classList.toggle('open', !open);
    body.classList.toggle('no-scroll', !open);
  });

  mobileShopToggle?.addEventListener('click', () => {
    const open = mobileShopToggle.getAttribute('aria-expanded') === 'true';
    mobileShopToggle.setAttribute('aria-expanded', String(!open));
    mobileShopToggle.setAttribute('aria-label', open ? 'Show Shop now categories' : 'Hide Shop now categories');
    if (mobileShopCategories) mobileShopCategories.hidden = open;
  });

  mobileMenu?.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
  document.querySelectorAll('.search-button').forEach(button => button.addEventListener('click', openSearch));
  document.querySelectorAll('.bag-button').forEach(button => button.addEventListener('click', openDrawer));
  document.querySelector('.drawer-close')?.addEventListener('click', closeOverlays);
  document.querySelector('.search-close')?.addEventListener('click', closeOverlays);
  scrim?.addEventListener('click', closeOverlays);

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') { closeOverlays(); closeMenu(); }
  });

  document.querySelectorAll('.quick-add[data-variant-id]').forEach(button => {
    button.addEventListener('click', async () => {
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
        await addVariant(button.dataset.variantId);
        button.textContent = 'Added ✓';
      } catch (error) {
        button.textContent = error.message;
      } finally {
        setTimeout(() => { button.textContent = original; button.disabled = false; }, 1400);
      }
    });
  });

  document.querySelectorAll('.js-product-form').forEach(form => {
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      const status = form.querySelector('.form-status');
      const id = new FormData(form).get('id');
      const quantity = new FormData(form).get('quantity') || 1;
      const original = button?.textContent;
      if (button) { button.disabled = true; button.textContent = 'Adding…'; }
      if (status) status.textContent = '';
      try {
        await addVariant(id, quantity);
        if (button) button.textContent = 'Added ✓';
      } catch (error) {
        if (status) status.textContent = error.message;
      } finally {
        setTimeout(() => { if (button) { button.textContent = original; button.disabled = false; } }, 1400);
      }
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach(select => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const price = select.closest('[data-product-section]')?.querySelector('[data-product-price]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
    });
  });

  document.querySelectorAll('[data-variant-option]').forEach(option => {
    option.addEventListener('change', () => {
      if (!option.checked) return;
      const section = option.closest('[data-product-section]');
      const price = section?.querySelector('[data-product-price]');
      const submit = section?.querySelector('.product-submit');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (submit) {
        submit.disabled = option.disabled;
        submit.textContent = option.disabled ? 'Sold out' : 'Add to bag';
      }
    });
  });

  document.querySelectorAll('.quantity-stepper').forEach(stepper => {
    const input = stepper.querySelector('input[name="quantity"]');
    const update = amount => {
      const current = Number.parseInt(input?.value || '1', 10);
      if (input) input.value = Math.max(1, current + amount);
    };
    stepper.querySelector('[data-quantity-minus]')?.addEventListener('click', () => update(-1));
    stepper.querySelector('[data-quantity-plus]')?.addEventListener('click', () => update(1));
  });

  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('visible'); revealObserver.unobserve(entry.target); }
    });
  }, { threshold: .12 }) : null;
  document.querySelectorAll('.reveal').forEach(element => revealObserver ? revealObserver.observe(element) : element.classList.add('visible'));

  document.addEventListener('shopify:section:load', () => location.reload());
})();
